<h1 mat-dialog-title> Editar Proveedor </h1> <br/>

<mat-dialog-content>
    <form #proveedorForm=ngForm>
        <p>
            <mat-label>
                <h2> Datos de Proveedor </h2>
            </mat-label>
        </p>
        <p>
            <mat-form-field appearance="outline" class="mat-input">

                <mat-label> RUT </mat-label>

                <input name="rut" value="{{proveedor.rutProveedor}}-{{proveedor.dvProveedor}}" matInput [(ngModel)]="proveedor.rut" #rut="ngModel" />

            </mat-form-field>
        </p>
        <p>
            <mat-form-field appearance="outline" class="mat-input">

                <mat-label> Nombre Proveedor </mat-label>

                <input name="nombreProveedor" value={{data.nombreProveedor}} matInput required [(ngModel)]="proveedor.nombreProveedor" #nombreProveedor="ngModel" (ngModelChange)="proveedor.nombreProveedor = $event.toUpperCase()" />

            </mat-form-field>
        </p>

        <p>
            <mat-form-field appearance="outline" class="mat-input">

                <mat-label> Nombre Corto </mat-label>

                <input name="nombreCorto" matInput required value="{{data.nombreCorto}}" [(ngModel)]="proveedor.nombreCorto" #nombreCorto="ngModel" (ngModelChange)="proveedor.nombreCorto = $event.toUpperCase()" />

            </mat-form-field>
        </p>
        <p>
            <mat-form-field appearance="outline" class="mat-input">

                <mat-label> Código Finanzas </mat-label>

                <input name="codigoFin" value={{data.codigoFin}} matInput required [(ngModel)]="proveedor.codigoFin" #codigoFin="ngModel" (ngModelChange)="proveedor.codigoFin = $event.toUpperCase()" />

            </mat-form-field>
        </p>
        <p>
            <mat-form-field appearance="outline" class="mat-input">

                <mat-label> Dirección </mat-label>

                <input name="direccion" matInput required value="{{data.direccion}}" [(ngModel)]="proveedor.direccion" #direccion="ngModel" (ngModelChange)="proveedor.direccion = $event.toUpperCase()" />

            </mat-form-field>
        </p>


        <p>
            <mat-form-field appearance="outline" class="mat-input">

                <mat-label> Regiones </mat-label>

                <mat-select name="region" #region="ngModel" [(ngModel)]="proveedor.idRegion" (selectionChange)="cargaComunas(proveedor.idRegion)">

                    <mat-option *ngFor="let region_ of this.data.regiones" [value]="region_.codigo">

                        {{region_.nombre}}

                    </mat-option>

                </mat-select>

            </mat-form-field>
        </p>
        <p>
            <mat-form-field appearance="outline" class="mat-input">

                <mat-label> Comuna</mat-label><br/>

                <mat-select name="comuna" #comuna="ngModel" [(ngModel)]="proveedor.idComuna">

                    <mat-option *ngFor="let comuna of this.data.comunas" [value]="comuna.codigo">

                        {{comuna.nombre}}

                    </mat-option>

                </mat-select>
            </mat-form-field>
        </p>

        <p>
            <mat-form-field appearance="outline" class="mat-input">

                <mat-label> Categoría</mat-label>

                <mat-select name="categoria" [(ngModel)]="proveedor.idCategoria" #categoria="ngModel">

                    <mat-option *ngFor="let cat of this.data.categorias" [value]="cat.id">

                        {{cat.descripcion}}

                    </mat-option>
                </mat-select>

            </mat-form-field>
        </p>
        <p>
            <mat-form-field appearance="outline" class="mat-input">

                <mat-label> Mínimo Cuotas</mat-label>

                <mat-select name="minCuotas" [(ngModel)]="proveedor.minCuotas" #minCuotas="ngModel">

                    <mat-option *ngFor="let c of this.data.cuotas" [value]="c.id">

                        {{c.descripcion}}

                    </mat-option>

                </mat-select>


            </mat-form-field>
        </p>
        <p>
            <mat-form-field appearance="outline" class="mat-input">

                <mat-label> Máximo Cuotas</mat-label>

                <mat-select name="idCuotas" [(ngModel)]="proveedor.idCuotas" #idCuotas="ngModel">

                    <mat-option *ngFor="let c of this.data.cuotas" [value]="c.id">

                        {{c.descripcion}}

                    </mat-option>

                </mat-select>


            </mat-form-field>
        </p>

        <p *ngIf="data.rol == 'ROLE_ADMINISTRADOR' || data.rol == 'ROLE_CONTABILIDAD' || data.rol == 'ROLE_ENCARGADO_CONTABILIDAD'">
            <mat-form-field appearance="outline" class="mat-input">

                <mat-label> Visible en Convenio</mat-label><br/>

                <mat-select name="visibleConvenio" [(ngModel)]="proveedor.visibleConvenio" #visibleConvenio="ngModel">

                    <mat-option *ngFor="let visible of this.visibles" [value]="visible.id">
                        {{visible.nombre}}
                    </mat-option>
                </mat-select>


            </mat-form-field>
        </p>
    </form>
</mat-dialog-content> <br/>

<mat-dialog-actions>
    <button  *ngIf="data.rol != 'ROLE_COORDINADOR'" mat-button class="mat-raised-button btn-success" (click)="onGuardarEdicionClick(proveedorForm)"> 
                <i class = "fa fa-plus"> </i> Guardar
    </button>

    <button mat-button class="mat-raised-button btn-dark" (click)="onCancelarClick()"> 
                <i class = "fa fa-trash"> </i> Salir
    </button>

</mat-dialog-actions>